module.exports = __webpack_public_path__ + "img/menu-active.609368c9.svg";